import cx from 'classnames';
import PropTypes from 'prop-types';

import { LIST_ITEM_DEFINITIONS } from '@xing-com/content-editor-plugin-helpers';

import { LIST_ITEM_TAG_NAME } from './constants';
import styles from './ListItem.css';

const ListItem = ({
  className,
  LIST_ITEM_TAG = LIST_ITEM_TAG_NAME,
  ...attributes
}) => {
  const RenderLeaf = ({
    children,
    element: { type },
    attributes: elementAttributes,
  } = {}) => {
    if (type === LIST_ITEM_DEFINITIONS.type) {
      return (
        <LIST_ITEM_TAG
          {...attributes}
          {...elementAttributes}
          data-editor-plugin={LIST_ITEM_DEFINITIONS.type}
          className={cx(styles.listItem, className)}
        >
          {children}
        </LIST_ITEM_TAG>
      );
    }
  };
  return RenderLeaf;
};

ListItem.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  LIST_ITEM_TAG: PropTypes.node,
};

export { ListItem };
